module.exports = __webpack_public_path__ + "img/front02_img.0db89f74.png";